/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { FormattedMessage } from 'react-intl';
import { selectNotification } from './slice/selectors';
import { useSnackbar } from 'notistack';
import { useNotificationsSlice } from './slice';
import { IconButton } from '@mui/material'; // Import IconButton from Material-UI
import CloseIcon from '@mui/icons-material/Close'; // Import CloseIcon from Material-UI

export default function Notifications() {
  const { actions } = useNotificationsSlice();

  const dispatch = useDispatch();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar(); // Destructure closeSnackbar from useSnackbar

  const notification = useSelector(selectNotification);

  useEffect(() => {
    if (notification) {
      enqueueSnackbar(`${notification.message || 'Something went wrong'}`, {
        variant: notification.type,
        autoHideDuration: 3000,
        preventDuplicate: true,
        hideIconVariant: notification.hideIconVariant,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        onClose: () => dispatch(actions.clearNotification()),
        action: (
          key, // Add the close button action
        ) => (
          <IconButton
            aria-label="close"
            color="inherit"
            onClick={() => closeSnackbar(key)} // Close the notification when button is clicked
          >
            <CloseIcon />
          </IconButton>
        ),
      });
    }
  }, [notification]);

  return <></>;
}
